module.exports = __webpack_public_path__ + "static/media/EmotionalDiffusionTechniques.d0511d6d.mp3";